import React from 'react'
import { Box } from '@mui/material'
import { AppWithoutLayout, AppWithoutLayoutContainer } from '../components/layout/AppWithoutLayout'
import { ReactComponent as FarmlandsProLogoColored } from '../assets/images/FarmlandsProLogoColored.svg'

export const BlockingPage: React.FC<{
  children: React.ReactNode | React.ReactNode[]
  'data-testid': string
}> = (props) => {
  return (
    <AppWithoutLayoutContainer data-testid={props['data-testid']}>
      <AppWithoutLayout>
        <Box mb={2} mt={2}>
          <FarmlandsProLogoColored width={170} height={'31px'} />
        </Box>
        {props.children}
      </AppWithoutLayout>
    </AppWithoutLayoutContainer>
  )
}
